export type ProductListColumn = {
  label: string;
  field: string;
  sort?: boolean;
  /** GET /product/products `sortBy` value for a sortable column (the field stored on the product). */
  sortKey?: string;
  width: number;
  alwaysVisible?: boolean;
};

export const PRODUCT_LIST_COLUMN_STORAGE_KEY = "hkp.productList.visibleExtraColumns";

export const PRODUCT_LIST_COLUMNS: ProductListColumn[] = [
  { label: "SrNo", field: "orgSrNo", sort: true, sortKey: "orgSrNo", width: 1.2, alwaysVisible: true },
  { label: "Image", field: "logo", sort: false, width: 1.1, alwaysVisible: true },
  { label: "Product Name", field: "productName", sort: true, sortKey: "name", width: 6, alwaysVisible: true },
  { label: "Status", field: "status", sort: false, width: 3, alwaysVisible: true },
  { label: "Stock", field: "stock", sort: false, width: 1.6, alwaysVisible: true },
  { label: "Prices", field: "prices", sort: false, width: 2.2, alwaysVisible: true },
  { label: "DesignNo", field: "designNo", sort: true, sortKey: "designNum", width: 2.2 },
  { label: "Color", field: "color", sort: false, width: 2.2 },
  { label: "Creator Organization", field: "orgName", sort: true, sortKey: "createdByOrganization", width: 2.6 },
  // Owners show the creator studio when the stored owner is blank, so a sort on the stored
  // field would not match what is shown. No sort icon for them.
  { label: "Design Owner", field: "designOwner", sort: false, width: 2.6 },
  { label: "Product Owner", field: "productOwner", sort: false, width: 2.6 },
  { label: "HKPtagNo", field: "srNo", sort: true, sortKey: "srNo", width: 1.8 },
  { label: "HKP Tag", field: "nfcTag", sort: true, sortKey: "xuid", width: 1.8 },
  { label: "Created at", field: "createdAt", sort: true, sortKey: "createdAt", width: 2.2 },
  { label: "Actions", field: "actions", width: 3.2, alwaysVisible: true },
];

export const OPTIONAL_PRODUCT_LIST_COLUMNS = PRODUCT_LIST_COLUMNS.filter(
  (column) => !column.alwaysVisible
);

const OPTIONAL_FIELDS = new Set(OPTIONAL_PRODUCT_LIST_COLUMNS.map((column) => column.field));

export const parseStoredProductListColumns = (raw: string | null): string[] => {
  if (!raw) {
    return [];
  }
  try {
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) {
      return [];
    }
    return parsed.filter((field) => typeof field === "string" && OPTIONAL_FIELDS.has(field));
  } catch {
    return [];
  }
};

export const visibleProductListColumns = (extraFields: string[]): ProductListColumn[] => {
  const extra = new Set(extraFields);
  return PRODUCT_LIST_COLUMNS.filter(
    (column) => column.alwaysVisible || extra.has(column.field)
  );
};

export const HeaderData = {
  columns: PRODUCT_LIST_COLUMNS,
};
